import React from "react"
import {decode} from "he"
import DOMPurify from "dompurify"
import {safeLinkifyHtml} from "utils/safeLinkifyHtml"

const normalizeAnchorHtml = (html: string) => {
    const doc = new DOMParser().parseFromString(html, "text/html")
    doc.querySelectorAll("a[href]").forEach((anchor) => {
        const href = anchor.getAttribute("href")
        if (!href) {
            return
        }

        const rel = new Set((anchor.getAttribute("rel") || "").split(/\s+/).filter(Boolean))
        rel.add("noopener")
        rel.add("noreferrer")
        anchor.setAttribute("target", "_blank")
        anchor.setAttribute("rel", Array.from(rel).join(" "))
    })

    return doc.body.innerHTML
}

export const LinkifyContent = ({content}: {content: string}) => {
    const html = DOMPurify.sanitize(normalizeAnchorHtml(safeLinkifyHtml(decode(content))))

    const handleClickCapture = (e: React.MouseEvent<HTMLDivElement>) => {
        if (!(e.target instanceof Element)) {
            return
        }

        const anchor = e.target.closest("a")

        if (!anchor) {
            return
        }

        e.stopPropagation()
    }

    return (
        <div
            style={{whiteSpace: "pre-line"}}
            onClickCapture={handleClickCapture}
            dangerouslySetInnerHTML={{__html: html}}
        />
    )
}
